import { render, staticRenderFns } from "./TableSales.vue?vue&type=template&id=23149214&"
import script from "./TableSales.vue?vue&type=script&lang=js&"
export * from "./TableSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports